<template>
  <div class="content">
    <h1 class="title strong">
      <span v-for="(letter, index) in 'Talk to the flag!'" :key="index">{{
        letter
      }}</span>
    </h1>
  </div>
  <div class="content">
    <p class="instruction">{{ store.getLabel('gameInstructions') }}</p>
  </div>
  <div class="content">
    <h2>{{ store.getLabel('createGame') }}</h2>
    <InputField
      v-model="playerName"
      :id="'playerName'"
      :placeholder="store.getLabel('placeholder')"
      :default-value="playerName"
      :size="20"
      :maxlength="18"
      :aria-label="'playerName'"
      :is-disabled="!hasSpeechPossibility"
    ></InputField>
  </div>
  <div class="content">
    <div class="radio-group">
      <label class="radio-label">
        <input
          type="radio"
          value="en"
          v-model="selectedLangId"
          name="language"
          :disabled="!hasSpeechPossibility"
        />
        english
      </label>
      <label class="radio-label">
        <input
          type="radio"
          value="nl"
          v-model="selectedLangId"
          name="language"
          :disabled="!hasSpeechPossibility"
        />
        nederlands
      </label>
    </div>
  </div>
  <div class="content">
    <!--h2>{{ store.getLabel('settings') }}</h2-->
    <div class="select-group">
      <label for="continents">{{ store.getLabel('cont') }}</label>
      <select
        id="continents"
        v-model="selectedContinentOption"
        :disabled="!hasSpeechPossibility"
      >
        <option
          v-for="(continentOption, index) in continentOptions"
          :key="index"
          :value="index"
        >
          {{ continentOption[selectedLangId] }}
        </option>
      </select>
    </div>
    <div class="select-group">
      <label for="difficulty">{{ store.getLabel('diff') }}</label>
      <select
        id="difficulty"
        v-model="selectedDifficultyId"
        :disabled="!hasSpeechPossibility"
      >
        <option v-for="(diff, index) in difficulty" :key="index" :value="index">
          {{ diff[selectedLangId] }}
        </option>
      </select>
    </div>
    <button
      class="button"
      :disabled="!hasSpeechPossibility || playerName == ''"
      @click="setUpNewGame"
    >
      {{ store.getLabel('start') }}
    </button>
  </div>
  <div class="content">
    <p>{{ store.getLabel('online') }} {{ totalPlayersOnline }}</p>
  </div>
</template>

<script setup>
import { useFlagStore } from '@/store';
import InputField from '@/components/InputField.vue';
import { ref, computed, watch } from 'vue';
defineOptions({
  name: 'StartElement',
});
const playerName = ref('');
const store = useFlagStore();
playerName.value = store.getLastPlayerName;

const difficulty = store.getDifficulty;
const continentOptions = store.getContinentOptions;
const selectedDifficultyId = ref(0);
const selectedContinentOption = ref(0);
const selectedLangId = ref('nl');
if (store.getCurrentLanguageId) {
  selectedLangId.value = store.getCurrentLanguageId;
} else {
  selectedLangId.value = 'nl';
}

const hasSpeechPossibility = computed(() => store.getSpeechPossibility);

const setUpNewGame = async () => {
  try {
    await store.initAudio(selectedLangId.value);
  } catch (err) {
    const errStr = store.getErrorMessage(err);
    store.setModal({
      content: 'microphone trouble:' + errStr,
      title: 'error',
      eventName: '',
      type: 'notification',
    });
  }
  store.setUpNewGame({
    playerName: playerName.value,
    languageId: selectedLangId.value,
    difficultyId: selectedDifficultyId.value,
    continentOption: selectedContinentOption.value,
  });
};
//watch for change in selectedLangId and store it in the store
watch(selectedLangId, () => {
  store.setCurrentLanguageId(selectedLangId.value);
});
const totalPlayersOnline = computed(() => store.totalPlayersOnline);
</script>

<style scoped>
.select-group {
  display: flex;
  flex-wrap: wrap;
  flex-direction: row;
  justify-content: center;
  text-align: left;
  align-items: center;
  gap: calc(1 * var(--default-margin));
}
.select-group label {
  display: block;
}
.radio-group {
  justify-content: center;
  display: flex;
  gap: calc(1 * var(--default-margin));
}

.radio-label {
  display: flex;
  align-items: center;
  gap: calc(0.5 * var(--default-margin));
}

.title span {
  display: inline-block;
  animation:
    wave 4s infinite,
    colorChange 5s infinite;
}
</style>
